/* eslint-disable */
export default {
  dial: 'Nummer kiezen',
  message: 'Bericht',
  transfer: 'Doorschakelen',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
